import { useState } from 'react'
import { AlertTriangle } from 'lucide-react'
import WarCrimeReportModal from './WarCrimeReportModal'

// ANU-89 — entry-point button for filing a war crime report.
// Mounted in PlayerView (bottom, live events only) and RefereeView.
// Visible only during live events; the spec is explicit on this so
// players can't file during prep / debrief windows.
export default function WarCrimeReportButton({ eventId, eventStatus, factionId }) {
  const [open, setOpen] = useState(false)
  if (eventStatus !== 'live') return null
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          width: '100%',
          minHeight: 56,
          padding: '14px 16px',
          background: 'rgba(255,42,42,.08)',
          border: '1px solid rgba(255,42,42,.45)',
          color: '#ff6a3d',
          fontFamily: "'Rajdhani', 'Saira Condensed', sans-serif",
          fontSize: 15,
          fontWeight: 700,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
        }}
      >
        <AlertTriangle size={16} /> WAR CRIME
      </button>
      {open && (
        <WarCrimeReportModal
          eventId={eventId}
          factionId={factionId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
